import React, { useReducer, useContext } from 'react';
import { Form } from 'semantic-ui-react';
import ReactInputMask from 'react-input-mask';
import { GlobalContext } from 'globalContext';
import { toQuery } from 'utils';

const initialState = {
    empresa: 1,
    tipo_pagamento: 'todos',
    data_pgto: '',
    data_pgto_fim: '',
};

function formReducer(state, action) {
    switch (action.type) {
        case 'reset':
            return initialState;

        case 'payload':
            return state;

        default:
            return { ...state, ...action.payload };
    }
}

export default function FormularioPesquisa({ handleData }) {
    const [form, setForm] = useReducer(formReducer, initialState);

    const [{ empresas }] = useContext(GlobalContext);

    const companies =
        empresas
            ?.filter((companie) => companie.tipo === 'POSTO')
            .sort((a, b) => {
                if (a.nomeEmpresa > b.nomeEmpresa) {
                    return 1;
                }

                if (a.nomeEmpresa < b.nomeEmpresa) {
                    return -1;
                }
                return 0;
            }) ?? [];

    companies.unshift({
        _id: 1,
        nomeEmpresa: 'TODOS OS POSTOS',
    });

    function handleChangeSelect(e, { name, value }) {
        setForm({ payload: { [name]: value } });
    }

    function handleChange(event) {
        if (event.target) {
            const { name, value } = event.target;

            return setForm({ payload: { [name]: value } });
        }
    }

    function cleanup() {
        setForm({ type: 'reset' });
    }

    const paymentsType = [
        { value: 'todos', key: 0, text: 'Todos' },
        { value: 'profrota', key: 1, text: 'Pro Frota' },
        { value: 'ticket_log', key: 2, text: 'Ticket LOG' },
    ];

    return (
        <Form>
            <Form.Group>
                <Form.Field width="3">
                    <label>Empresa</label>
                    <Form.Select
                        search
                        value={form.empresa}
                        name="empresa"
                        placeholder="Selecione uma empresa"
                        selectOnBlur={false}
                        options={companies?.map((companie) => ({
                            key: companie._id,
                            value: companie._id,
                            text: `${companie.nomeEmpresa}`,
                        }))}
                        onChange={handleChangeSelect}
                    />
                </Form.Field>

                <Form.Field width="3">
                    <label>Tipo de pagamento</label>
                    <Form.Select
                        value={form.tipo_pagamento}
                        selectOnBlur={false}
                        name="tipo_pagamento"
                        placeholder="Selecione um tipo de pagamento"
                        options={paymentsType}
                        onChange={handleChangeSelect}
                    />
                </Form.Field>
                <Form.Field>
                    <label>Data pagamento</label>
                    <Form.Input
                        children={
                            <ReactInputMask
                                value={form.data_pgto}
                                mask="99/99/9999"
                                placeholder="Data início"
                                name="data_pgto"
                                onChange={handleChange}
                            />
                        }
                    />
                </Form.Field>

                <Form.Field>
                    <label>&nbsp;</label>
                    <Form.Input
                        children={
                            <ReactInputMask
                                value={form.data_pgto_fim}
                                mask="99/99/9999"
                                placeholder="Data fim"
                                name="data_pgto_fim"
                                onChange={handleChange}
                            />
                        }
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Button
                        disabled={
                            (form.data_pgto === '' && form.data_pgto_fim === '') ||
                            form.empresa === ''
                        }
                        label="&nbsp;"
                        content="Buscar"
                        onClick={() => handleData(toQuery(form))}
                        icon="search"
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Button
                        disabled={
                            form.data_pgto === '' &&
                            form.empresa === '' &&
                            form.tipo_pagamento === '' &&
                            form.data_pgto_fim === ''
                        }
                        label="&nbsp;"
                        content="Limpar"
                        onClick={() => cleanup()}
                        icon="trash"
                    />
                </Form.Field>
            </Form.Group>
        </Form>
    );
}
